import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
var css = {
  "checkboxWrapper": "rui-TLmk0",
  "square": "rui-oJ7bt",
  "icon": "rui-omSYY",
  "roundedCorners": "rui-vgubO",
  "label": "rui-zxgMZ",
  "checked": "rui-4ViBy"
};
import Icon from '../Icon/Icon';
import cx from 'classnames';
var Checkbox = /*#__PURE__*/function (_React$Component) {
  function Checkbox() {
    var _this;
    _classCallCheck(this, Checkbox);
    _this = _callSuper(this, Checkbox, arguments);
    _this.componentDidUpdate = function (prevProps) {
      var prevValue = prevProps.value;
      var value = _this.props.value;
      if (value !== prevValue) {
        _this.setState({
          checkState: value
        });
      }
    };
    _this.state = {
      checkState: !!_this.props.value
    };
    _this.handleCheck = function (event) {
      _this.setState({
        checkState: event.target.checked
      }, function () {
        var _a, _b;
        (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, _this.state.checkState, _this.props.name);
      });
    };
    return _this;
  }
  _inherits(Checkbox, _React$Component);
  return _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        disabled = _this$props.disabled,
        id = _this$props.id,
        name = _this$props.name,
        extras = _this$props.extras,
        label = _this$props.label,
        labelTitle = _this$props.labelTitle,
        style = _this$props.style,
        iconSize = _this$props.iconSize,
        roundedCorners = _this$props.roundedCorners,
        className = _this$props.className,
        labelClassName = _this$props.labelClassName,
        inputClassName = _this$props.inputClassName,
        iconLabelstyle = _this$props.iconLabelstyle,
        theme = _this$props.theme;
      var checkState = this.state.checkState;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(css.checkboxWrapper, className),
        style: style
      }, /*#__PURE__*/React.createElement("div", {
        className: cx(css.square, _defineProperty({}, css.disabled, disabled))
      }, /*#__PURE__*/React.createElement("input", Object.assign({
        id: id,
        key: "new-checkbox-field",
        name: name,
        type: "checkbox",
        value: "".concat(checkState),
        onChange: this.handleCheck,
        disabled: disabled,
        checked: checkState,
        className: cx(_defineProperty(_defineProperty({}, css.disabled, disabled), css.roundedCorners, roundedCorners), inputClassName)
      }, extras)), checkState && /*#__PURE__*/React.createElement("label", {
        className: css.icon,
        htmlFor: id,
        style: iconLabelstyle
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "ok",
        size: iconSize,
        color: "white",
        theme: theme
      }))), label && /*#__PURE__*/React.createElement("label", {
        className: cx(css.label, _defineProperty({}, css.checked, checkState), labelClassName),
        htmlFor: id,
        title: labelTitle
      }, label));
    }
  }]);
}(React.Component);
Checkbox.defaultProps = {
  onChange: function onChange() {},
  id: '',
  name: '',
  disabled: false,
  value: false,
  label: '',
  extras: {},
  labelTitle: '',
  iconSize: 23,
  roundedCorners: false,
  className: '',
  inputClassName: '',
  labelClassName: '',
  theme: 'olx'
};
export default Checkbox;